/* 🤖 this file was generated by svg-to-ts */
export const DfIconArrowBackwardCircle16: {
  name: 'arrow-backward-circle-16';
  data: string;
} = {
  name: 'arrow-backward-circle-16',
  data: `<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16zm3.221-6.09a.5.5 0 0 0 .71-.67C11.167 7.957 10.04 7.22 8.502 7a.502.502 0 0 1-.503-.5v-.996a.497.497 0 0 0-.85-.353L4.146 7.643a.5.5 0 0 0 0 .707l3.004 2.51a.496.496 0 0 0 .85-.355v-1.13c.88-.704 1.956-.317 3.221.535z"/></svg>`
};
